import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const SPEC_FILTERS = [
  ['type', 'DDR Type'], ['cap', 'Capacity', (v) => `${v}GB`], ['speed', 'Speed', (v) => `${v} MT/s`],
  ['ff', 'Form Factor'], ['rank', 'Rank'], ['volt', 'Voltage'], ['die', 'Die Density'], ['org', 'Chip Org'],
  ['cond', 'Condition'],
];
const CONDITIONS = [['F/S', 'Factory Sealed'], ['REF', 'Refurbished'], ['New', 'New']];

const FilterSelect = ({ id, label, fmt, options, value, onChange }) => (
  <div>
    <div className="text-[10px] font-mono uppercase tracking-wider text-[#64748B] mb-1">{label}</div>
    <Select value={value || 'all'} onValueChange={(v) => onChange(id, v === 'all' ? '' : v)}>
      <SelectTrigger className="bg-[#05050A] border-[#334155] h-10 font-mono text-sm" data-testid={`filter-${id}`}>
        <SelectValue placeholder="All" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All</SelectItem>
        {options.map(([v, l]) => (
          <SelectItem key={v} value={String(v)} data-testid={`filter-${id}-option-${v}`}>{fmt ? fmt(l) : l}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const InventoryFilters = ({ facets, values, onChange, onClear }) => {
  const active = SPEC_FILTERS.some(([k]) => values[k]);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3 mt-4" data-testid="spec-filters">
      {SPEC_FILTERS.map(([id, label, fmt]) => {
        const options = id === 'cond' ? CONDITIONS : (facets[id] || []).map((v) => [v, v]);
        if (id !== 'cond' && options.length === 0) return null;
        return <FilterSelect key={id} id={id} label={label} fmt={fmt} options={options} value={values[id]} onChange={onChange} />;
      })}
      {active && (
        <button onClick={onClear} className="col-span-full justify-self-start text-xs font-mono text-cyan-400 hover:text-white" data-testid="filters-clear-btn">
          Clear all filters
        </button>
      )}
    </div>
  );
};

export default InventoryFilters;
